<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div>Version {{ version }} &copy; {{ currentYear }} Teddy mais BB - Todos os direitos reservados.</div>
    </div>
  </div>
</footer>
